import { CONFIG } from "./backendUrl";

export const apiUrl = "https://dev-api.asista.kz";


// https://api.asista.kz